import React from 'react';

type Props = {
    id        : ID
    shortId   : ID
    title     : string
    close     : callback
    fadeTime  : number
}

export default class TaskCreated extends React.Component<Props> {

    openTask = () => {
        gd.taskView.open(this.props.id, null);
        this.props.close();
    };

    copyLink = () => {
        const url = 'https://www.goodday.work/t/'+this.props.id;
        gd.utils.copyToClipboard(url);
        gd.growl.success("Link copied to clipboard");
        this.props.close();
    };

    render() {

        const classes = Classes("notification","h-100-percent", "create")

        return (
            <div className={classes} style={{transition: "opacity "+this.props.fadeTime+"s"}}>
                <div className="flex-row-left-top">
                    <div className="left-indicator">
                        <div className="i5-done ui5-color-green fs-15 create-icon"/>
                    </div>
                    <div className="right-content">
                        <div className="ui5-txt-not-important-small m-b-8">Task created</div>
                        <div className="ui5-txt-less-important-small txt-truncate max-w-225 m-b-8">{this.props.title}</div>
                        <div className="flex-row-between-center">
                            <div className="flex-row-left-center">
                                <div className="flex-row-left-center link m-r-20" onClick={this.openTask}>
                                    <div className="i5-open-new-window m-r-5"></div>
                                    <div className="ui5-txt-link-tiny">Open</div>
                                </div>

                                <div className="flex-row-left-center link" onClick={this.copyLink}>
                                    <div className="i5-link m-r-5"></div>
                                    <div className="ui5-txt-link-tiny">Copy link</div>
                                </div>
                            </div>

                            <div className="ui5-txt-not-important">#{this.props.shortId}</div>
                        </div>
                    </div>
                </div>
                <div className="close i5-delete" onClick={this.props.close}/>
            </div>
        )
    }
}
